import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

const AuthShell = ({ title, subtitle, children, footer }: Props) => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
    <div className="w-full max-w-md">
      <Link to="/login" className="mb-6 flex items-center justify-center gap-2 text-tfs-primary">
        <span className="flex size-8 items-center justify-center rounded-lg bg-tfs-primary text-sm font-semibold text-white">
          T
        </span>
        <span className="text-base font-semibold">TFSIQ</span>
      </Link>

      <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>

      {footer && <div className="mt-4 text-center text-sm text-slate-500">{footer}</div>}
    </div>
  </div>
);

export default AuthShell;
